import styled, { css } from 'styled-components';
import applyResponsiveVdpStyles from '../../../_shared/helpers/applyResponsiveVdpStyles';
import Icon from '../../../_shared/components/Icon';

/**
 * Variant Definitions
 */
const StyledTIAHVariants = {
  mini: css`
    width: 100%;
  `,
  expanded: css`
    box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.2);
    width: 853px;
    margin-right: 18px;
    margin-top: 15px;
    background-color: ${({ theme }) => theme.COLORS.BASE};
  `
};

export const StyledTradeInIcon = styled(Icon).attrs({
  icon: 'TR5-Invited_Customer'
})`
  height: 18px;
  width: 18px;
  fill: ${({ theme }) => theme.COLORS.INFO};
  display: inline-block;
  margin: 0 0 10px 8px;
`;

export const StyledHeader = styled.div`
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  display: flex;
  flex-direction: row;
`;

export const StyledHeaderText = styled.div`
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  margin-left: 10px;
`;
export const StyledText = styled.div`
  padding: 7px 8px;
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  font-family: ${({ theme }) => theme.FONT.REGULAR};
`;

export const StyledName = styled.div`
  padding: 7px 10px 8px 8px;
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  font-family: ${({ theme }) => theme.FONT.REGULAR};
`;
export const StyledPhone = styled.div`
  padding: 7px 10px 8px 8px;
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  color: ${({ theme }) => theme.COLORS.TERTIARY};
  cursor: pointer;
`;
export const StyledEmail = styled.div`
  padding: 7px 10px 8px 8px;
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  text-decoration: underline;
  color: ${({ theme }) => theme.COLORS.TERTIARY};
  cursor: pointer;
`;

export const StyledTIAHContainer = styled.div`
  display: flex;
  flex-direction: column;
  ${({ theme }) =>
    applyResponsiveVdpStyles(theme, {
      mini: StyledTIAHVariants.mini,
      expanded: StyledTIAHVariants.expanded
    })}
`;

export const StyledTIAHWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 20px;
`;

export const StyledCustomerDetails = styled.div`
  display: flex;
  flex-direction: row;
`;
